import React from "react";

const TaskIncompleteActionIcon = (props) => (
    <svg className={props.className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Incomplete Job"}</title>
        <path
            d="M4.375 6.80957H14.6875V19.1846H4.375V6.80957Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.87988 4.30957H17.1924V16.6846" stroke={props.color || "#00549A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="15.625" cy="13.9346" r="4" fill="white" stroke={props.color || "#00549A"} strokeWidth="1.5" />
        <path
            d="M16.9427 12.5296L16.9427 12.5296C17.0123 12.576 17.0606 12.6481 17.077 12.7302C17.0935 12.8122 17.0766 12.8974 17.0302 12.967L15.5064 15.2528L15.5064 15.2528C15.4805 15.2916 15.4463 15.3242 15.4063 15.3482C15.3663 15.3722 15.3214 15.3871 15.275 15.3917L15.2749 15.3917C15.2646 15.3927 15.2542 15.3932 15.2439 15.3932L16.9427 12.5296ZM16.9427 12.5296C16.8731 12.4831 16.7879 12.4663 16.7058 12.4827C16.6238 12.4991 16.5516 12.5474 16.5052 12.617L16.5052 12.617L15.1949 14.5826M16.9427 12.5296L15.1949 14.5826M15.1949 14.5826L14.7051 14.0928C14.6758 14.0635 14.641 14.0402 14.6027 14.0244C14.5644 14.0085 14.5234 14.0004 14.482 14.0004C14.4406 14.0004 14.3995 14.0085 14.3613 14.0244C14.323 14.0402 14.2882 14.0635 14.2589 14.0928C14.2296 14.1221 14.2064 14.1568 14.1905 14.1951C14.1747 14.2334 14.1665 14.2744 14.1665 14.3158C14.1665 14.3573 14.1747 14.3983 14.1905 14.4366C14.2064 14.4749 14.2296 14.5096 14.2589 14.5389L15.0208 15.3008L15.0208 15.3008C15.0501 15.3301 15.0849 15.3534 15.1232 15.3692C15.1614 15.3851 15.2025 15.3932 15.2439 15.3932L15.1949 14.5826Z"
            fill={props.color || "#00549A"}
            stroke={props.color || "#00549A"}
            strokeWidth="0.25"
        />
    </svg>
);

export default TaskIncompleteActionIcon;
